import {
  AttributeTemplateItem,
} from "../views/app/settings/AttributeTemplateTypes";
import {
  CreateAttributeTemplatePayload,
  UpdateAttributeTemplatePayload,
} from "../types/app/attributeTemplateTypes";

export const mapAttributeTemplateToCreatePayload = (
  template: AttributeTemplateItem,
): CreateAttributeTemplatePayload => ({
  name: template.name.trim(),
  description: template.description.trim(),
  isActive: template.isActive,
  attributes: template.attributes.map((attribute, attributeIndex) => ({
    // id: attribute.id,
    name: attribute.name.trim(),
    type: attribute.type,
    isRequired: attribute.isRequired,
    sortOrder: attributeIndex + 1,
    code: attribute.code,
    options: attribute.options.map((option, optionIndex) => ({
      value: option.value,
      label: option.label,
      sortOrder: optionIndex + 1,
      imageUrl: option.imageUrl,
      priceModifier: option.priceModifier,
    })),
  })),
});

export const mapAttributeTemplateToUpdatePayload = (
  template: AttributeTemplateItem,
): UpdateAttributeTemplatePayload => ({
  id: template.id,
  templateId: template.templateId || template.id,
  ...(template.storeId ? { storeId: template.storeId } : {}),
  name: template.name.trim(),
  description: template.description.trim(),
  isActive: template.isActive,
  attributes: template.attributes.map((attribute, attributeIndex) => ({
    id: attribute.id,
    name: attribute.name.trim(),
    type: attribute.type,
    isRequired: attribute.isRequired,
    sortOrder: attributeIndex + 1,
    code: attribute.code,
    options: attribute.options.map((option, optionIndex) => ({
      value: option.value,
      label: option.label,
      sortOrder: optionIndex + 1,
      imageUrl: option.imageUrl,
      priceModifier: option.priceModifier,
    })),
  })),
});
